// Dollar parsing helpers for TopBuildingsList money cell editor.
// Mudmap owns its own copy in mudmapAmountInput.ts — do not import from there.

export const DOLLAR_INPUT_OPTIONS = {
  numeral: true,
  numeralThousandsGroupStyle: "thousand",
  numeralDecimalScale: 0,
  numeralPositiveOnly: true,
};

const SUFFIX_MULTIPLIER: Record<string, number> = {
  b: 1_000_000_000,
  m: 1_000_000,
  k: 1_000,
};

/**
 * Parse a dollar amount field. Bare numbers are taken literally; k/m/b suffixes multiply.
 *
 *   "500"         → 500           "10m"  → 10_000_000
 *   "10.5k"       → 10_500        "25,000,000" → 25_000_000
 */
export function parseLiteralDollarInput(raw: string): number | null {
  const s = raw.replace(/[$,\s]/g, "").toLowerCase();
  const match = s.match(/^((?:\d+(?:\.\d*)?|\.\d+))(b|m|k)?$/);
  if (!match) return null;
  const n = parseFloat(match[1]);
  if (!Number.isFinite(n)) return null;
  const multiplier = match[2] ? SUFFIX_MULTIPLIER[match[2]] : null;
  if (multiplier !== null) return Math.round(n * multiplier);
  return Math.round(n);
}

export function formatDollarAmount(value: number): string {
  return value.toLocaleString("en-US");
}

/** Unparseable text is handed back untouched so the user can see and fix it. */
export function normalizeDollarInput(raw: string): string {
  const n = parseLiteralDollarInput(raw);
  return n !== null ? formatDollarAmount(n) : raw;
}
